import { readFile } from "fs/promises";
import "path";
import { h as headToHeadAnalysis } from "../../../../../chunks/headToHeadAnalysis.js";
import { p as pastgameSummary } from "../../../../../chunks/getForm.js";
const games22Path = "src/pulse_past.json";
const filePath = "src/_games.json";
const prerender = false;
async function load({ fetch, params }) {
  const data = (
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    JSON.parse(await readFile(filePath, "utf8"))[params.id] ?? // (await read("/" + path.resolve("./") + "/" + games22Path).json())
    JSON.parse(await readFile(games22Path, "utf8"))[params.id] ?? await (await fetch(
      `https://ugpl-ce55b-default-rtdb.europe-west1.firebasedatabase.app/games/${params.id || ""}.json`
    )).json()
  );
  var hometeamform = Object.values(
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    JSON.parse(await readFile(filePath, "utf8"))
  ).filter(
    // fetchNew
    //   ? // Object.values({
    //     [
    //       // ...Object.values(JSON.parse(await readFile(games22Path, "utf8"))),
    //       ...
    (v, i, l) => (v.secondend != void 0 || v.patch_status == "finished") && // v.secondend &&
    !v.test && !(v.id.includes("test") || v.homeid.includes("test") || v.awayid.includes("test") || v.home.includes("test") || v.away.includes("test"))
  ).filter(
    (v, i, l) => v.id != params.id && // new Date(v.start).getTime() < new Date(data.start).getTime() &&
    (v?.homeid == data?.homeid || v?.awayid == data?.homeid)
    // ||
    // (v.homeid == data.awayid || v.awayid == data.awayid)
  ).map(pastgameSummary);
  var awayteamform = Object.values(
    // (await read("/" + path.resolve("./") + "/" + filePath).json())
    JSON.parse(await readFile(filePath, "utf8"))
  ).filter(
    // fetchNew
    //   ? // Object.values({
    //     [
    //       // ...Object.values(JSON.parse(await readFile(games22Path, "utf8"))),
    //       ...
    (v, i, l) => {
      return (v.secondend != void 0 || v.patch_status == "finished") && !v.test && !(v.id.includes("test") || v.homeid.includes("test") || v.awayid.includes("test") || v.home.includes("test") || v.away.includes("test"));
    }
  ).filter(
    (v, i, l) => v.id != params.id && // new Date(v.start).getTime() < new Date(data.start).getTime() &&
    // (v.homeid == data.homeid || v.awayid == data.homeid) ||
    (v?.homeid == data?.awayid || v?.awayid == data?.awayid)
  ).map(pastgameSummary);
  hometeamform.sort(
    (b, a) => new Date(a.firststart ?? a.start).getTime() - new Date(b.firststart ?? b.start).getTime()
  );
  awayteamform.sort(
    (b, a) => new Date(a.firststart ?? a.start).getTime() - new Date(b.firststart ?? b.start).getTime()
  );
  var headtohead = (
    // Object.values({
    [
      ...Object.values(
        // (await read("/" + path.resolve("./") + "/" + games22Path).json())
        JSON.parse(await readFile(games22Path, "utf8"))
      ),
      ...Object.values(
        // (await read("/" + path.resolve("./") + "/" + filePath).json())
        JSON.parse(await readFile(filePath, "utf8"))
      ).filter(
        (v, i, l) => v.secondend != void 0 || v.patch_status == "finished"
        //   &&
        // new Date(v.secondend).toISOString() < new Date().toISOString()
      )
    ].filter(
      (v, i, l) => v.id != params.id && new Date(v.start).getTime() < new Date(data.start).getTime() && (v.homeid == data.homeid || v.awayid == data.homeid) && (v.homeid == data.awayid || v.awayid == data.awayid)
    ).map(headToHeadAnalysis)
  );
  headtohead.sort(
    (b, a) => new Date(a.start).getTime() - new Date(b.start).getTime()
  );
  return {
    id: params.id,
    match: data,
    headtohead: headtohead.slice(0, 5),
    hometeamform: hometeamform.slice(0, 5),
    awayteamform: awayteamform.slice(0, 5)
  };
}
export {
  load,
  prerender
};
